import React, { useMemo, useState } from 'react';
import Styles from './index.scss';
import { $k18n } from '@/common/i18n';
import { useRouter } from '@/hooks/useRouter';
import { TextInput, View } from 'react-native';
import searchIcon from './searchIcon.png';
import clearIcon from './clearIcon.png';
import { styles } from '@/common/style';
import { useLoginStore } from '@/component/LoginSdk/store/useLoginStore';
import { Toast } from '@kibt/meta-ui-krn';
import { openUrl } from '@/common/bridge/openUrl';
import shoppingCenter from './shoppingCenter.png';
import signOut from './signOut.png';
import { isIOS } from '@/common/device-info';
import { FixedBottomPanel } from '@/component/LoginSdk/components/FixedBottomPanel';

const ProfileIconCdnUrl = 'https://cdn-static.kwai.net/kos/s101/nlav11312/pwa-images/default-head.png';
const KwaiLogo = 'https://cdn-static.kwai.net/kos/s101/nlav11312/pwa-images/kwai_logo.png';

interface TopBarProps {
    currentUserHeadUrl?: string;
}
const KWAI_HOME_URL = 'https://www.kwai.com';
const TopBar: React.FC<TopBarProps> = () => {
    const { userInfo, setLoginModelVisible, isLogin, logout } = useLoginStore(state => ({
        userInfo: state.userInfo,
        isLogin: state.isLogin,
        setLoginModelVisible: state.setLoginModelVisible,
        logout: state.logout,
    }));

    const actionList = [
        {
            icon: shoppingCenter,
            desc: '我的订单',
            onClick: () =>
                openUrl({
                    url: '/shop/c/order-list',
                }),
        },
        {
            icon: signOut,
            desc: 'Sign out',
            onClick: () => handleLogout(),
        },
    ];

    const [focus, setFocus] = useState(false);
    const [showBottomPanel, setShowBottomPanel] = useState(false);
    const router = useRouter();
    const [value, setValue] = useState('');

    const handleLogoClick = () => {
        window.location.href = KWAI_HOME_URL;
    };

    const handleAvatarClick = () => {
        if (isLogin) {
            setShowBottomPanel(true);
        } else {
            setLoginModelVisible(true);
        }
    };
    async function handleLogout() {
        const logoutSuccess = await logout();
        if (logoutSuccess) {
            Toast.show({
                text: $k18n('Log out successful'),
            }).then(() => {
                setShowBottomPanel(false);
                window.location.reload();
            });
        }
    }

    const handleSearchClick = () => {
        window.open(`${KWAI_HOME_URL}/discover/${value} `);
    };
    const userHeadUrl = useMemo(() => {
        return userInfo?.headurl || ProfileIconCdnUrl;
    }, [userInfo]);

    return (
        <div className={`${Styles.topBarContainer}`}>
            <div className={Styles.nav}>
                <img src={KwaiLogo} alt="logo" className={Styles.logo} onClick={handleLogoClick} />
                <div className={`${Styles.inputWrapper} ${focus && !value ? Styles.inputWrapperValue : ''}`}>
                    <img src={searchIcon} className={Styles.prefixIcon} />
                    <TextInput
                        value={value}
                        onFocus={() => {
                            setFocus(true);
                        }}
                        onBlur={() => {
                            setFocus(false);
                        }}
                        onChangeText={value => {
                            setValue(value);
                        }}
                        style={styles({
                            paddingLeft: 26,
                            fontWeight: 700,
                            paddingRight: 26,
                            height: 36,
                            flex: 1,
                            width: 40, //避免撑开容器
                        })}
                        placeholder={$k18n('')}
                        className={Styles.textInput}
                    />
                    <View>
                        {value ? (
                            <img
                                src={clearIcon}
                                className={`${Styles.clearable}`}
                                onClick={() => {
                                    setValue('');
                                }}
                            />
                        ) : null}
                    </View>
                </div>
            </div>
            {!value ? (
                <img className={Styles.avatar} src={userHeadUrl} alt="avatar" onClick={handleAvatarClick} />
            ) : (
                <div onClick={handleSearchClick} className={Styles.searchText}>
                    {$k18n('Search')}
                </div>
            )}

            <FixedBottomPanel
                visible={showBottomPanel}
                onClose={() => {
                    setShowBottomPanel(false);
                }}>
                <div className={Styles.signOutTextWrapper}>
                    {actionList.map(item => {
                        return (
                            <div className={Styles.actionItem}>
                                <img src={item.icon} alt="" />
                                <div className={Styles.signOutText} onClick={item.onClick}>
                                    {$k18n(item.desc)}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </FixedBottomPanel>
        </div>
    );
};
export default TopBar;
